
define('text!modules/list/list_item_template.html',[],function () { return '<li class="list-item" data-index="<%= index %>  ">\r\n  <%=value%>\r\n</li>\r\n';});

